<div class="footer" [class.transparent]="embedService.embed">
  @if (!embedService.embed) {
    <p>powered by <a href="https://catch.hr/" target="_blank"><b>catchHR</b></a></p>
  }
  <div class="links">
    <a href="https://catch.hr/impressum" target="_blank">{{'jobboard.static.footer.imprint' |
      transloco}}</a> | <a (click)="privacyModal.modal.open();">{{'jobboard.static.footer.privacy' | transloco}}</a>
  </div>
  @if (embedService.embed) {
  <ng-select [placeholder]="'jobboard.static.header.language' | transloco"
    [items]="languages" [bindValue]="'value'" [dropdownPosition]="'top'" [bindLabel]="'name'"
    (change)="languageService.setLanguage($event.value)" [searchable]="false" [clearable]="false">
  </ng-select>
  }
</div>

<app-privacy-modal #privacyModal></app-privacy-modal>